// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__7VlPw","error":"Input_error__LmhZE"};